import {TitleDescr, LinkDescr, ImageDescr, Button, Button2} from './descrItems';
import ItemDescr from './itemDescr';

export default ItemDescr;
export {TitleDescr, LinkDescr, ImageDescr, Button, Button2};
